/** Parse service timestamps as UTC when the service omits a timezone. */
export default function parseUtcDate(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    if (typeof value !== 'string') {
        return new Date(value);
    }

    let timestamp = value.trim().replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(timestamp)) {
        timestamp += 'T00:00:00Z';
    } else if (/^\d{4}-\d{2}-\d{2}T/.test(timestamp) && !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(timestamp)) {
        timestamp += 'Z';
    }
    return new Date(timestamp);
}
